import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import star from "../../Images/star.png";
import CloseImg from "../../Images/CloseImg.png";
import { AppContext, useAppContext } from "./../../AppContext";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import plusImage1 from "../../Images/plusImage1.png";
import minusImage1 from "../../Images/minusImage1.png";
import deleteImage from "../../Images/deleteImage.png";
import { Carousel } from "antd";
import arrowleft from "../../Images/arrowleft.png";
import arrowright from "../../Images/arrowright.png";
import shoppingbag from "../../Images/shoppingbag.png";
import { useHistory } from "react-router-dom";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import AllCategoriesCartDialog from "../AllCategoriesComponents/AllCategoriesCartDialog";
import LottifileLoading from "../../LottifileLoading.json";
import Lottie from "lottie-react";
import { useTranslation } from "react-i18next";
import { MyDomain } from "../../App";

const label = { inputProps: { "aria-label": "Checkbox demo" } };

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width:
      window.innerWidth <= 1920
        ? "90%"
        : window.innerWidth <= 2560
        ? "70%"
        : window.innerWidth <= 3840
        ? "60%"
        : "50%", // Full width minus 5% padding on each side
    margin: "0 auto", // Center the modal horizontally
    maxWidth: "none", // Disable the default max width
    borderRadius: 0,
  },
}));

export default function ProfileWishList() {
  const { t, i18n } = useTranslation();
  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const user = JSON.parse(localStorage.getItem("user"));

  const handleDivClick2 = (CategoryName, ProductId) => {
    CreateRecently(ProductId);
    history.push(`/product/${ProductId}`);
  };
  const CreateRecently = (IdOfProduct) => {
    const now = new Date();
    const formattedDate = now.toLocaleDateString("en-GB").split("/").join("-");
    const formattedTime = now.toTimeString().slice(0, 5);
    const data = {
      UserId: user?.userId,
      ProductId: IdOfProduct,
      TheDate: formattedDate,
      TheTime: formattedTime,
    };
    axios
      .post(`${MyDomain}Recently/CreateRecently`, data) // API URL for adding products to the cart
      .then((response) => {
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };
  useEffect(() => {
    document.body.style.overflowX = "hidden";

    // Target the .slick-list element within the carousel wrapper div
    const slickList = wrapperRef.current?.querySelector(".slick-list");
    if (slickList) {
      slickList.style.overflow = "visible";
      slickList.style.clipPath = "inset(0px 0px -150px 0px)";
      //slickList.style.paddingBottom = "50px"; // Adjust padding as needed to control dropdown overflow at the bottom
    }
    // Cleanup function to reset body style on component unmount
    return () => {
      document.body.style.overflowX = "";
    };
  }, []);
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      /* Webkit Browsers (Chrome, Safari, Edge) */
      div::-webkit-scrollbar {
        width: 4px;
        height: 4px;
      }

      div::-webkit-scrollbar-track {
        background: transparent;
      }

      div::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 4px;
      }

      div::-webkit-scrollbar-thumb:hover {
        background: #aaa;
      }

      div::-webkit-scrollbar-button {
        display: none;
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);
  const [CartData, setCartData] = useState([]);
  const [TotalAmount, setTotalAmount] = useState(0);
  const [SaveTotalPrice, setSaveTotalPrice] = useState(0);

  // Close dropdown if clicked outside
  useEffect(() => {
    setCartData([]);
    //event.preventDefault();
    const data = {
      UserId: user?.userId,
    };

    axios
      .post(`${MyDomain}Cart/GetUserCart`, data) // replace with your API URL
      .then((response) => {
        setCartData(response.data);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  }, []);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [WishListData, setWishListData] = useState([]);
  const [RecommendedProductsData, setRecommendedProductsData] = useState([]);

  const Dates = ["All", "Perfumes", "Fill like Categories"];
  const [DateChoosing, setDateChoosing] = useState(0);

  useEffect(() => {
    //GetUserWishList();
    GetRecommendedProducts();
  }, []);

  const GetRecommendedProducts = () => {
    setRecommendedProductsData([]);

    const data = {
      UserId: user?.userId,
    };
    axios
      .post(`${MyDomain}RecommendedProducts/GetRecommendedProductsById`, data)
      .then((response) => {
        console.log(response.data);
        setRecommendedProductsData(response.data);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };
  const [CategoriesNames, setCategoriesNames] = useState([]);
  const [FilterByCategory, setFilterByCategory] = useState([]);

  const [data, setData] = useState([]); // Store API response data
  const [categories, setCategories] = useState(["All"]); // Store unique categories
  const [selectedCategory, setSelectedCategory] = useState("All"); // Selected category

  const [Loading, setLoading] = useState(false); // Selected category

  // Fetch data from API
  useEffect(() => {
    setLoading(false);

    const data = {
      UserId: user?.userId,
    };
    axios
      .post(`${MyDomain}WishList/GetUserWishListProducts`, data) // Replace with your API URL
      .then((response) => {
        console.log(response.data);
        setData(response.data); // Save the response data
        const uniqueCategories = [
          "All",
          ...new Set(response.data.map((item) => item.category)),
        ];
        setCategoriesNames(categories);
        setWishListData(response.data);
        setFilterByCategory(response.data);
        setCategories(uniqueCategories);
        setLoading(true);
      })
      .catch((err) => {
        console.log(err.response.data);
        setLoading(true);
      });
  }, []);

  // Filter data based on the selected category
  const filteredData =
    selectedCategory === "All"
      ? data
      : data.filter((item) => item.category === selectedCategory);

  const [wishlist, setWishlist] = useState(
    JSON.parse(localStorage.getItem("wishList")) || []
  );
  const { CartAmount, setCartAmount } = useContext(AppContext);
  const { WishList, setWishList } = useAppContext();

  const DeleteFromWishList = async (DelproductId) => {
    axios
      .delete(`${MyDomain}WishList/DeleteFromWishList`, {
        data: { ProductId: DelproductId, UserId: user?.userId },
      })
      .then((response) => {
        setWishList(response.data);

        let updatedWishlist;
        updatedWishlist = wishlist.filter(
          (item) =>
            item.productId !== DelproductId && item.userId === user?.userId
        );
        const updatedList = WishListData.filter(
          (item) => item.id !== DelproductId
        );
        setWishListData(updatedList); // Update state with the new array
        setData(updatedList);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };
  // Group items into rows of 3
  const rows = [];
  for (let i = 0; i < WishListData.length; i += 3) {
    rows.push(WishListData.slice(i, i + 3));
  }
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setMyOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [currentSlide, setCurrentSlide] = useState(0);
  const carouselRef = React.createRef();

  const handleBeforeChange = (from, to) => {
    setCurrentSlide(to);
  };

  const [isHovered, setIsHovered] = useState(false);
  const [hoverStates, setHoverStates] = useState({}); // Store hover states for each ID
  const handleMouseEnter = (id) => {
    setHoverStates((prev) => ({ ...prev, [id]: true }));
  };

  const handleMouseLeave = (id) => {
    setHoverStates((prev) => ({ ...prev, [id]: false }));
  };

  const CreateProduct = (IdOfProduct) => {
    setCartData([]);
    //event.preventDefault();
    const data = {
      UserId: user?.userId,
      IdOfProduct: IdOfProduct,
      AmountOfProduct: 1,
    };
    axios
      .post(`${MyDomain}Cart/AddProductToCart`, data) // replace with your API URL
      .then((response) => {
        //setResponseMessage("Data submitted successfully!");
        console.log(response.data);
        setCartData(response.data);

        const userCart = response.data?.userCart || [];
        const products = response.data?.products || [];

        // Calculate total price with discount logic
        const totalPrice = userCart.reduce((accumulator, cartItem) => {
          const product = products.find((p) => p.id === cartItem.idOfProduct);
          if (product) {
            const { price, discount, theDeal } = product;
            const { amountOfProduct } = cartItem;
            let total = 0;

            if (theDeal === 1) {
              // Apply discount to all items
              total += price * (1 - discount / 100) * amountOfProduct;
            } else {
              // Apply discount only to every nth item
              for (let i = 1; i <= amountOfProduct; i++) {
                if (i % theDeal === 0) {
                  total += price * (1 - discount / 100);
                } else {
                  total += price;
                }
              }
            }

            return accumulator + total;
          }
          return accumulator; // If no matching product, skip
        }, 0);
        setSaveTotalPrice(totalPrice);
        setCartAmount(response.data.userCart.length);
        handleClickOpen();
      })
      .catch((err) => {
        //setResponseMessage("Error submitting data.");
        console.log(err.response.data);
      });
  };

  const CreateProduct2 = (IdOfProduct) => {
    const data = {
      UserId: user?.userId,
      IdOfProduct: IdOfProduct,
      AmountOfProduct: 1, // Default to adding 1 product to the cart
    };

    axios
      .post(`${MyDomain}Cart/AddProductToCart`, data) // API URL for adding products to the cart
      .then((response) => {
        console.log(response.data);

        // Update cart data in state
        setCartData(response.data);

        const userCart = response.data?.userCart || [];
        const products = response.data?.products || [];

        // Calculate total price with discount logic
        const totalPrice = userCart.reduce((accumulator, cartItem) => {
          const product = products.find((p) => p.id === cartItem.idOfProduct);
          if (product) {
            const { price, discount, theDeal } = product;
            const { amountOfProduct } = cartItem;
            let total = 0;

            if (theDeal === 1) {
              // Apply discount to all items
              total += price * (1 - discount / 100) * amountOfProduct;
            } else {
              // Apply discount only to every nth item
              for (let i = 1; i <= amountOfProduct; i++) {
                if (i % theDeal === 0) {
                  total += price * (1 - discount / 100);
                } else {
                  total += price;
                }
              }
            }

            return accumulator + total;
          }
          return accumulator; // If no matching product, skip
        }, 0);

        setSaveTotalPrice(totalPrice);
        setCartAmount(response.data.userCart.length);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };

  const wrapperRef = useRef();

  // Function to group products into chunks of specified size
  const chunkArray = (array, size) => {
    if (!Array.isArray(array) || array.length === 0) {
      return []; // Return an empty array if input is not a valid array
    }

    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };
  const numItemsPerSlide = 5; // Change this to 4 if you want 4 items per slide
  const slides = chunkArray(RecommendedProductsData.products, numItemsPerSlide); // Grouping products into chunks of 4
  const [ProductsData, setProductsData] = useState([]);
  const next = () => {
    carouselRef.current.next();
  };

  const prev = () => {
    carouselRef.current.prev();
  };
  function ProductCard({
    id,
    productId,
    image,
    title,
    subtitle,
    price: initialPrice,
    discount: initialdiscount,
    deals,
    thedeal: initialthedeal,
    dropDown,
    isHeartClicked,
    onHeartClick,
  }) {
    const [isDivHovered, setIsDivHovered] = useState(false);
    const [isHeartHovered, setIsHeartHovered] = useState(false);
    const selectRef = useRef(null);
    const handleBlur = () => {
      selectRef.current.blur();
    };
    //DropDown
    const [price, setPrice] = useState(initialPrice);
    const [discount, setDiscount] = useState(
      initialdiscount === 0 ? null : price - (price * initialdiscount) / 100
    );
    const [thedeal, setThedeal] = useState(initialthedeal);
    const [hoverThedeal, setHoverThedeal] = useState(null); // Temporary price for hover

    const [hoverDiscount, setHoverDiscount] = useState(null); // Temporary price for hover
    const [hoverPrice, setHoverPrice] = useState(null); // Temporary price for hover
    const [theDiscount, setTheDiscount] = useState(initialdiscount);
    const [hoverTheDiscount, sethoverTheDiscount] = useState(null);
    const [IdOfProduct, setIdOfProduct] = useState(id);
    const [CartData, setCartData] = useState([]);

    const [isOpen, setIsOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
      setIsModalOpen(true);
    };
    const handleOk = () => {
      setIsModalOpen(false);
    };
    const handleCancel = () => {
      setIsModalOpen(false);
    };
    const [selectedOption, setSelectedOption] = useState(""); // Default selected option
    const dropdownRef = useRef(null); // Reference to the dropdown
    const newArray1 = ProductsData.filter(
      (item) => item.productId === productId
    );
    // Extract only the productId values
    const productDropDowns = newArray1.map((item) => item.dropDown);

    // Close dropdown if clicked outside
    useEffect(() => {
      setCartData([]);
      const data = {
        UserId: user?.userId,
      };

      axios
        .post(`${MyDomain}Cart/GetUserCart`, data) // replace with your API URL
        .then((response) => {
          setCartData(response.data);
        })
        .catch((err) => {
          console.log(err.response.data);
        });
      setSelectedOption(productDropDowns[0]);
      const handleClickOutside = (event) => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target)
        ) {
          setIsOpen(false); // Close dropdown if the click is outside the dropdown
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [dropdownRef]);

    const history = useHistory();
    const handleDivClick = (CategoryName, ProductId) => {
      //history.push(`/${CategoryName}`);
      history.push(`/product/${ProductId}`);
    };
    return (
      <div
        onMouseEnter={() => setIsDivHovered(true)}
        onMouseLeave={() => {
          setIsDivHovered(false);
        }}
        style={{
          display: "flex",
          flexDirection: "column",
          cursor: "pointer",
          position: "relative", // Make the parent position relative for proper placement of the heart icon
          width: "19.5%",
          marginRight: 20,
        }}
      >
        <div
          style={{
            backgroundColor: isDivHovered || isHeartHovered ? "white" : "",
            display: "flex",
            position: "absolute",
            top: "2px",
            right: "2px",
            padding: 3,
            borderRadius: 50,
          }}
          onClick={() => {
            CreateProduct2(id);
          }}
        >
          <img
            src={shoppingbag}
            alt="shoppingbag"
            style={{
              width: 20,
              height: 20,
            }}
          />
        </div>
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            margin: 0,
            backgroundColor: "black",
            transition: "color 0.3s ease",
            cursor: "pointer",
          }}
        ></div>
        <div
          style={{
            backgroundColor: "#fafafa",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            //flexGrow: 1,
            //height: "350px", // Ensure consistent height
          }}
          onClick={() => {
            handleDivClick("product", productId);
          }}
        >
          <img
            src={image}
            alt={title}
            style={{
              width: 150,
              height: 150,
              // maxHeight: "100%",
              // maxWidth: "100%",
              objectFit: "contain",
            }}
          />
        </div>
        <p
          style={{
            fontSize: 15,
            marginBottom: 1,
            margin: 0,
            color: isHeartHovered ? "blue" : "",
          }}
          onClick={() => {
            handleDivClick("product", productId);
          }}
          onMouseEnter={() => setIsHeartHovered(true)}
          onMouseLeave={() => setIsHeartHovered(false)}
        >
          {title}
        </p>
        <p
          style={{
            fontSize: 12,
            opacity: 0.5,
            margin: 0,
          }}
        >
          {subtitle}
        </p>
        <p style={{ fontSize: 12, opacity: 0.5, margin: 0 }}>{dropDown}</p>

        {/* <div style={{ display: "flex", flexDirection: "row" }}>
          {[1, 2, 3, 4, 5].map((_, idx) => (
            <img
              key={idx}
              src={star}
              alt="star"
              style={{
                width: 8,
                height: 8,
                marginLeft: 3,
                marginBottom: 15,
              }}
            />
          ))}
        </div> */}
        {theDiscount === 0 ? (
          <>
            <p
              style={{
                margin: 0,
                paddingBottom: 5,
                fontSize: 15,
              }}
            >
              ₪{price}
            </p>
            <a
              style={{
                fontSize: 12,
              }}
            >
              &nbsp;
            </a>
          </>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: thedeal === 1 ? "row" : "column",
              //flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              {thedeal === 1 ? (
                <>
                  <p
                    style={{
                      margin: 0,
                      paddingBottom: 5,
                      fontSize: 15,
                      color: "red",
                    }}
                  >
                    ₪{(price - (price * theDiscount) / 100).toFixed(2)}
                  </p>
                  &nbsp; &nbsp;
                  <p
                    style={{
                      margin: 0,
                      paddingBottom: 5,
                      fontSize: 15,
                      textDecoration: "line-through",
                    }}
                  >
                    ₪{price}
                  </p>
                </>
              ) : (
                <>
                  <p
                    style={{
                      margin: 0,
                      paddingBottom: 5,
                      fontSize: 15,
                      //textDecoration: "line-through",
                    }}
                  >
                    ₪{price}
                  </p>
                </>
              )}
            </div>
            <div>
              <p style={{ margin: 0 }}>
                <a
                  style={{
                    fontSize: 15,
                  }}
                >
                  {thedeal === 1 ? (
                    <>
                      <p
                        style={{
                          backgroundColor: "#6b21a8",
                          color: "white",
                          margin: 0,
                          marginBottom: 5,
                          paddingLeft: 5,
                          paddingRight: 5,
                          fontSize: 15,
                        }}
                      >
                        -{theDiscount}%
                      </p>
                      <a
                        style={{
                          fontSize: 12,
                        }}
                      >
                        &nbsp;
                      </a>
                    </>
                  ) : (
                    // "Buy " + theDeal + "pcs to get -" + item.discount
                    <>
                      <a
                        style={{
                          backgroundColor: "#6b21a8",
                          color: "white",
                          fontSize: 12,
                          paddingLeft: 5,
                          paddingRight: 5,
                        }}
                      >
                        Buy 2 pcs to get -{theDiscount}% off every {thedeal}
                        {thedeal === 2 ? "nd" : "th"} item
                      </a>
                    </>
                  )}
                </a>
              </p>
            </div>
          </div>
        )}
      </div>
    );
  }
  const history = useHistory();
  const handleDivClick1 = (CategoryName) => {
    history.push(`/${CategoryName}`);
  };

  const calculateTotalPrice = (price, amount, discount, discountOnEvery) => {
    let total = 0;

    for (let i = 1; i <= amount; i++) {
      if (i % discountOnEvery === 0) {
        // Apply discount to every 'discountOnEvery' item
        total += price * (1 - discount / 100);
      } else {
        // Add full price for non-discounted items
        total += price;
      }
    }

    // Format the total to show decimals only when needed
    const formattedTotal = Number.isInteger(total)
      ? total.toString()
      : parseFloat(total.toFixed(2));

    return formattedTotal;
  };

  const [ReceiveNotifications, setReceiveNotifications] = useState("0");
  // Function to handle checkbox change
  const AddTrackPrice = async (productId) => {
    const data = {
      UserId: user?.userId,
      ProductId: productId,
    };

    axios
      .post(`${MyDomain}WishList/AddTrackPrice`, data) // replace with your API URL
      .then((response) => {
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };

  const HideFromTrackPrice = async (productId) => {
    const data = {
      UserId: user?.userId,
      ProductId: productId,
    };

    axios
      .post(`${MyDomain}WishList/HideFromTrackPrice`, data) // replace with your API URL
      .then((response) => {
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };
  const handleCheckboxChange = (id) => {
    // Update trackPrice based on toggle
    WishListData.forEach((item) => {
      if (item.id === id) {
        item.trackPrice = item.trackPrice === 1 ? 0 : 1; // Toggle between 1 and 0
        if (item.trackPrice === 1) {
          AddTrackPrice(id);
        } else {
          HideFromTrackPrice(id);
        }
      }
    });
    // Trigger re-render
    setWishListData([...WishListData]);
  };

  const CartDialog = () => {
    return (
      <>
        <React.Fragment>
          {/* <Button variant="outlined" onClick={handleClickOpen}>
            Open dialog
          </Button> */}
          <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            fullWidth
            maxWidth={false} // Disable Material-UI's default width settings
          >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
              {t("profile.Cart")}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={(theme) => ({
                position: "absolute",
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
              })}
            >
              <CloseIcon />
            </IconButton>

            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <div style={{ width: "70%", height: "calc(55vh - 55px)" }}>
                <div
                  style={{
                    height: "100%",
                    overflow: "auto", // Enables scrolling
                  }}
                >
                  {CartData.userCart &&
                    CartData.userCart.map((cartItem) => {
                      const product = CartData?.products?.find(
                        (p) => p.id === cartItem.idOfProduct
                      );
                      return (
                        <div style={{}}>
                          <div
                            key={cartItem.id}
                            style={{
                              width: "100%",
                              //background: "#f0f0f0",
                              padding: "10px",
                              flexDirection: "row",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              //backgroundColor: "blue",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                //backgroundColor: "gray",
                                cursor: "pointer",
                                width: "50%",
                              }}
                              onClick={() => {
                                handleDivClick1("product", product?.productId);
                              }}
                            >
                              <img
                                src={product?.image}
                                style={{
                                  width: 150,
                                  height: "100%",
                                  //opacity: currentSlide === 0 ? 0.3 : 1,
                                  cursor: currentSlide === 0 ? "" : "pointer",
                                  //backgroundColor: "red",
                                }}
                              />
                              <div>
                                <p
                                  style={{
                                    padding: 0,
                                    marginBottom: 5,
                                    fontSize: 15,
                                  }}
                                >
                                  {product?.name}
                                </p>
                                <p
                                  style={{
                                    padding: 0,
                                    margin: 0,
                                    opacity: 0.5,
                                  }}
                                >
                                  {product?.productType}
                                </p>
                                <p
                                  style={{
                                    padding: 0,
                                    margin: 0,
                                    opacity: 0.5,
                                  }}
                                >
                                  {product?.dropDown}
                                </p>
                                {product?.discount === 0 ? (
                                  <></>
                                ) : (
                                  <div style={{ display: "flex" }}>
                                    <p style={{ margin: 0 }}>
                                      <a
                                        style={{
                                          fontSize: 15,
                                        }}
                                      >
                                        {product?.theDeal === 1 ? (
                                          <div>
                                            <p
                                              style={{
                                                backgroundColor: "#6b21a8",
                                                color: "white",
                                                margin: 0,
                                                //marginBottom: 5,
                                                paddingLeft: 5,
                                                paddingRight: 5,
                                                fontSize: 15,
                                              }}
                                            >
                                              -{product?.discount}%
                                            </p>
                                            <a
                                              style={{
                                                fontSize: 12,
                                                margin: 0,
                                              }}
                                            ></a>
                                          </div>
                                        ) : (
                                          // "Buy " + theDeal + "pcs to get -" + item.discount
                                          <>
                                            <a
                                              style={{
                                                backgroundColor: "#6b21a8",
                                                color: "white",
                                                fontSize: 12,
                                                paddingLeft: 5,
                                                paddingRight: 5,
                                              }}
                                            >
                                              Buy 2 pcs to get -
                                              {product?.discount}% off every{" "}
                                              {product?.theDeal}
                                              {product?.theDeal === 2
                                                ? "nd"
                                                : "th"}{" "}
                                              item
                                            </a>
                                          </>
                                        )}
                                      </a>
                                    </p>
                                  </div>
                                )}

                                {/* <p
                                style={{ padding: 0, margin: 0, opacity: 0.5 }}
                              >
                                {product.discount}
                              </p> */}
                              </div>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                //backgroundColor: "yellow",
                                width: "35%",
                              }}
                            >
                              <button
                                title="minus"
                                style={{
                                  padding: 5,
                                  backgroundColor: "white",
                                  border: "1px solid #e7e5e4",
                                }}
                              >
                                {
                                  <img
                                    src={minusImage1}
                                    style={{
                                      width: 30,
                                      height: 30,
                                      margin: 0,
                                      //opacity: currentSlide === 0 ? 0.3 : 1,
                                      cursor:
                                        currentSlide === 0 ? "" : "pointer",
                                    }}
                                    onClick={() => {}}
                                  />
                                }
                              </button>
                              <p
                                style={{
                                  margin: 0,
                                  paddingRight: 15,
                                  paddingLeft: 15,
                                }}
                              >
                                {/* {AmountOfProduct} */}
                                {cartItem.amountOfProduct}
                              </p>
                              <button
                                type="button" // Prevent default form behavior
                                title="plus"
                                style={{
                                  padding: 5,
                                  backgroundColor: "white",
                                  border: "1px solid #e7e5e4",
                                }}
                              >
                                <img
                                  src={plusImage1}
                                  style={{
                                    width: 30,
                                    height: 30,
                                    margin: 0,

                                    //opacity: currentSlide === 0 ? 0.3 : 1,
                                    cursor: currentSlide === 0 ? "" : "pointer",
                                  }}
                                />
                              </button>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: "15%",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                }}
                              >
                                {product?.discount === 0 ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      paddingRight: "50%",
                                    }}
                                  >
                                    <p
                                      style={{
                                        margin: 0,
                                        fontSize: 15,
                                      }}
                                    >
                                      ₪
                                      {calculateTotalPrice(
                                        product?.price,
                                        cartItem?.amountOfProduct,
                                        product?.discount,
                                        product?.theDeal
                                      )}
                                    </p>
                                    <a
                                      style={{
                                        fontSize: 12,
                                      }}
                                    >
                                      &nbsp;
                                    </a>
                                  </div>
                                ) : (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                      }}
                                    >
                                      {product?.theDeal === 1 ? (
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                          }}
                                        >
                                          <p
                                            style={{
                                              margin: 0,
                                              fontSize: 15,
                                              textDecoration: "line-through",
                                            }}
                                          >
                                            ₪
                                            {product?.price *
                                              cartItem?.amountOfProduct}
                                          </p>
                                          <p
                                            style={{
                                              margin: 0,
                                              fontSize: 15,
                                              color: "red",
                                            }}
                                          >
                                            ₪
                                            {(
                                              product?.price -
                                              (product?.price *
                                                product?.discount) /
                                                100
                                            ).toFixed(2) *
                                              cartItem?.amountOfProduct}
                                          </p>
                                        </div>
                                      ) : (
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                          }}
                                        >
                                          {cartItem?.amountOfProduct === 1 ? (
                                            <></>
                                          ) : (
                                            <>
                                              <p
                                                style={{
                                                  margin: 0,
                                                  fontSize: 15,
                                                  textDecoration:
                                                    "line-through",
                                                }}
                                              >
                                                ₪
                                                {product?.price *
                                                  cartItem?.amountOfProduct}
                                              </p>
                                            </>
                                          )}
                                          <p
                                            style={{
                                              margin: 0,
                                              fontSize: 15,
                                              color:
                                                cartItem?.amountOfProduct !== 1
                                                  ? "red"
                                                  : "black",
                                            }}
                                          >
                                            ₪
                                            {calculateTotalPrice(
                                              product?.price,
                                              cartItem?.amountOfProduct,
                                              product?.discount,
                                              product?.theDeal
                                            )}
                                          </p>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>

                              <button
                                title="delete"
                                style={{
                                  backgroundColor: "white",
                                  border: "0px solid white",
                                }}
                              >
                                <img
                                  src={deleteImage}
                                  style={{
                                    width: 20,
                                    height: 20,
                                    margin: 0,
                                    opacity: hoverStates[product?.id] ? 1 : 0.5,
                                  }}
                                  onClick={() => {}}
                                  onMouseEnter={() =>
                                    handleMouseEnter(product?.id)
                                  }
                                  onMouseLeave={() =>
                                    handleMouseLeave(product?.id)
                                  }
                                />
                              </button>
                            </div>
                          </div>
                          <div
                            style={{
                              border: "0.2px solid #f4f4f5",
                              width: "100%",
                            }}
                          ></div>
                        </div>
                      );
                    })}
                </div>
              </div>
              <div
                style={{
                  width: "30%",
                  height: 200,
                  marginLeft: 20,
                  marginRight: 20,
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: "#fafafa",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    flexDirection: "row",
                    display: "flex",
                    width: "80%",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: 10,
                  }}
                >
                  <p style={{ margin: 0, fontSize: 15 }}>
                    {t("profile.Orderprice")}
                  </p>
                  <p style={{ margin: 0, fontSize: 15 }}>
                    ₪{SaveTotalPrice.toFixed(2)}
                  </p>
                </div>
                <div
                  style={{
                    height: "0.1px",
                    backgroundColor: "#e5e5e5",
                    width: "80%",
                  }}
                ></div>
                <div
                  style={{
                    flexDirection: "row",
                    display: "flex",
                    width: "80%",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: 10,
                  }}
                >
                  <p style={{ margin: 0, fontWeight: "bold", fontSize: 18 }}>
                    {t("profile.Totalamount")}
                  </p>
                  <p style={{ margin: 0, fontWeight: "bold", fontSize: 18 }}>
                    ₪{SaveTotalPrice.toFixed(2)}
                  </p>
                </div>
                <div style={{ width: "80%", padding: 10, paddingTop: 20 }}>
                  <button
                    style={{
                      backgroundColor: "#27272a",
                      width: "100%",
                      height: 50,
                      color: "white",
                      borderWidth: 0,
                    }}
                  >
                    {t("profile.Checkout")}
                  </button>
                </div>
              </div>
            </div>
            <div
              style={{
                alignItems: "center",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingRight: 30,
                }}
                onClick={prev}
              >
                <img
                  src={arrowleft}
                  style={{
                    width: 35,
                    height: 35,
                    opacity: currentSlide === 0 ? 0.3 : 1,
                    cursor: currentSlide === 0 ? "" : "pointer",
                  }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={next}
              >
                <img
                  src={arrowright}
                  style={{
                    width: 35,
                    height: 35,
                    opacity: currentSlide === slides.length - 1 ? 0.3 : 1,
                    cursor: currentSlide === slides.length - 1 ? "" : "pointer",
                  }}
                />
              </div>
            </div>
            <div
              style={{
                flexDirection: "row",
                display: "flex",
              }}
            >
              <div
                style={{
                  width: "20%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <p
                  style={{
                    margin: 0,
                    fontSize: 20,
                    paddingLeft: 15,
                    fontWeight: "500",
                  }}
                >
                  {t("profile.Recommended")}
                </p>
                <p
                  style={{
                    margin: 0,
                    fontSize: 20,
                    paddingLeft: 15,
                    fontWeight: "500",
                  }}
                >
                  {t("profile.products")}
                </p>
              </div>

              <div
                style={{
                  width: "80%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "calc(30vh - 55px)",
                  }}
                >
                  <div>
                    <div ref={wrapperRef}>
                      <Carousel
                        arrows={false}
                        infinite={false}
                        ref={carouselRef}
                        beforeChange={handleBeforeChange}
                        dots={false}
                      >
                        {slides.map((slide, index) => (
                          <div>
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                //justifyContent: "space-between",

                                justifyContent: "flex-start",
                                width: "100%",
                                direction:
                                  i18n.resolvedLanguage === "en" ? "" : "rtl",
                              }}
                            >
                              {slide.map((image, imgIndex) => {
                                const globalIndex =
                                  index * numItemsPerSlide + imgIndex;

                                return (
                                  <ProductCard
                                    key={globalIndex}
                                    id={
                                      RecommendedProductsData.products[
                                        globalIndex
                                      ].id
                                    }
                                    productId={
                                      RecommendedProductsData.products[
                                        globalIndex
                                      ].productId
                                    }
                                    image={
                                      RecommendedProductsData.products[
                                        globalIndex
                                      ].image
                                    }
                                    title={
                                      RecommendedProductsData.products[
                                        globalIndex
                                      ].name
                                    } //"Molinard Osmanthus"
                                    subtitle={
                                      RecommendedProductsData.products[
                                        globalIndex
                                      ].productType
                                    } //"Eau de Parfum"
                                    price={
                                      RecommendedProductsData.products[
                                        globalIndex
                                      ].price
                                    } //"₪ 19"
                                    discount={
                                      RecommendedProductsData.products[
                                        globalIndex
                                      ].discount
                                    }
                                    deals={
                                      RecommendedProductsData.products[
                                        globalIndex
                                      ].deals
                                    }
                                    thedeal={
                                      RecommendedProductsData.products[
                                        globalIndex
                                      ].theDeal
                                    }
                                    dropDown={
                                      RecommendedProductsData.products[
                                        globalIndex
                                      ].dropDown
                                    }
                                  />
                                );
                              })}
                            </div>
                          </div>
                        ))}
                      </Carousel>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </BootstrapDialog>
        </React.Fragment>
      </>
    );
  };
  const WindowsCustomWish = () => {
    return (
      <>
        {WishListData.length === 0 ? (
          <div
            style={{
              paddingLeft: 20,
              paddingTop: 20,
            }}
          >
            <a style={{ fontSize: 12 }}>No orders found</a>
          </div>
        ) : (
          <div
            style={{
              display: "grid",
              //gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
              gridTemplateColumns:
                MyWidth <= 1024 ? "repeat(2, 1fr)" : "repeat(3, 1fr)", // Exactly 3 items per row
              gap: "20px",
              marginBottom: "20px",
              direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
            }}
          >
            {filteredData.map((item) => (
              <div key={item.id}>
                <div
                  style={{
                    display: "flex",
                    backgroundColor: "#fafafa",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "space-between",
                      alignItems: "center",
                      flexDirection: "row",
                      display: "flex",
                      paddingTop: 5,
                    }}
                  >
                    <div style={{ backgroundColor: "#27272a" }}>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "10px",
                          color: "white",
                          // padding:
                          //   item.deals === "Deal"
                          //     ? 5
                          //     : item.deals === "Hit"
                          //     ? 5
                          //     : 0,

                          padding: item.deals !== "" ? 5 : 0,

                          paddingLeft: 10,
                          paddingRight: 10,
                          fontWeight: "bold",
                        }}
                      >
                        {/* {item.deals === "Deal"
                          ? "D E A L"
                          : item.deals === "Hit"
                          ? "H I T"
                          : ""} */}
                        {/* {item.deals} */}
                        {item.deals === "ORIGINAL" ? (
                          <>{t("profile.original")}</>
                        ) : item.deals === "MASTER" ? (
                          <>{t("profile.master")}</>
                        ) : (
                          ""
                        )}
                      </p>
                    </div>
                    <div style={{ paddingRight: 5 }}>
                      <img
                        src={CloseImg}
                        alt="close"
                        style={{
                          width: 22,
                          height: 22,
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          DeleteFromWishList(item.id);
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <img
                      src={item.image}
                      alt="Sample"
                      style={{
                        // maxHeight: "100%",
                        // maxWidth: "100%",
                        height: 300,
                        objectFit: "contain",
                      }}
                    />
                  </div>
                </div>

                <p
                  style={{
                    margin: 0,
                    paddingBottom: 10,
                    fontSize: 15,
                    paddingTop: 10,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleDivClick2("product", item.productId);
                  }}
                >
                  {item.name}
                </p>
                <p
                  style={{
                    margin: 0,
                    paddingBottom: 5,
                    opacity: 0.5,
                    fontSize: 15,
                  }}
                >
                  {item.productType}
                </p>
                <p style={{ margin: 0, fontSize: 15, color: "#22c55e" }}>
                  {item.inStock === "Yes"
                    ? t("profile.InStock")
                    : t("profile.Outofstock")}{" "}
                  {item.dropDown}
                </p>
                {/* <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  {[1, 2, 3, 4, 5].map((_, idx) => (
                    <img
                      key={idx}
                      src={star}
                      alt="star"
                      style={{
                        width: 8,
                        height: 8,
                        marginLeft: 3,
                        marginBottom: 15,
                      }}
                    />
                  ))}
                  &nbsp;
                  <p style={{}}>{item.numberUsersRating}</p>
                </div> */}

                {item.discount === 0 ? (
                  <>
                    {/* <p
                      style={{
                        margin: 0,
                        paddingBottom: 5,
                        fontSize: 15,
                      }}
                    >
                      ₪{item.price}
                    </p> */}

                    {item.priceInsteadOf === 0 ? (
                      <a
                        style={{
                          fontSize: 15,
                          paddingBottom: 5,
                        }}
                      >
                        ₪{item.price}
                      </a>
                    ) : (
                      <>
                        <a
                          style={{
                            margin: 0,
                            color: "red",
                            textDecoration: "line-through",
                            fontSize: 15,
                            paddingBottom: 5,
                          }}
                        >
                          ₪{item.price}
                        </a>
                        &nbsp;&nbsp;
                        <a
                          style={{
                            fontSize: 15,
                          }}
                        >
                          ₪{item.priceInsteadOf}
                        </a>
                      </>
                    )}
                    <a
                      style={{
                        fontSize: 12,
                      }}
                    >
                      &nbsp;
                    </a>
                  </>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: item.theDeal === 1 ? "row" : "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      {item.theDeal === 1 ? (
                        <>
                          <p
                            style={{
                              margin: 0,
                              paddingBottom: 5,
                              fontSize: 15,
                              color: "red",
                            }}
                          >
                            ₪
                            {(
                              item.price -
                              (item.price * item.discount) / 100
                            ).toFixed(2)}
                          </p>
                          &nbsp; &nbsp;
                          <p
                            style={{
                              margin: 0,
                              paddingBottom: 5,
                              fontSize: 15,
                              textDecoration: "line-through",
                            }}
                          >
                            ₪{item.price}
                          </p>
                        </>
                      ) : (
                        <>
                          <p
                            style={{
                              margin: 0,
                              paddingBottom: 5,
                              fontSize: 15,
                              //textDecoration: "line-through",
                            }}
                          >
                            ₪{item.price}
                          </p>
                        </>
                      )}
                    </div>
                    <div>
                      <p style={{ margin: 0 }}>
                        <a
                          style={{
                            fontSize: 15,
                          }}
                        >
                          {item.theDeal === 1 ? (
                            <>
                              <p
                                style={{
                                  backgroundColor: "#6b21a8",
                                  color: "white",
                                  margin: 0,
                                  marginBottom: 5,
                                  paddingLeft: 5,
                                  paddingRight: 5,
                                  fontSize: 15,
                                }}
                              >
                                -{item.discount}%
                              </p>
                              <a
                                style={{
                                  fontSize: 12,
                                }}
                              >
                                &nbsp;
                              </a>
                            </>
                          ) : (
                            // "Buy " + theDeal + "pcs to get -" + item.discount
                            <>
                              <a
                                style={{
                                  backgroundColor: "#6b21a8",
                                  color: "white",
                                  fontSize: 12,
                                  paddingLeft: 5,
                                  paddingRight: 5,
                                }}
                              >
                                Buy 2 pcs to get -{item.discount}% off every{" "}
                                {item.theDeal}
                                {item.theDeal === 2 ? "nd" : "th"} item
                              </a>
                            </>
                          )}
                        </a>
                      </p>
                    </div>
                  </div>
                )}

                <div style={{ flexDirection: "column", display: "flex" }}>
                  <button
                    style={{
                      color: "white",
                      backgroundColor: "#27272a",
                      borderWidth: 0,
                      height: 45,
                    }}
                    onClick={() => {
                      CreateProduct(item.id);
                    }}
                  >
                    {t("profile.Buy")}
                  </button>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      paddingTop: 10,
                    }}
                  >
                    <p style={{ fontSize: 15 }}>
                      <Checkbox
                        {...label}
                        icon={
                          <Box
                            sx={{
                              width: 18,
                              height: 18,
                              border: "1.4px solid black", // border for unchecked state
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginRight: 1,
                            }}
                          />
                        } // Unchecked icon
                        checkedIcon={
                          <Box
                            sx={{
                              width: 18,
                              height: 18,
                              border: "1.4px solid black", // border for checked state
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginRight: 1,
                            }}
                          >
                            <Box
                              sx={{
                                width: 10, // smaller square inside
                                height: 10,
                                backgroundColor: "black", // color of the small square
                              }}
                            />
                          </Box>
                        } // Checked icon with small square
                        checked={item.trackPrice === 1} // Check based on PriceTrack value
                        onChange={() => handleCheckboxChange(item.id)} // Update state by ID
                        // checked={ReceiveNotifications === "1"}
                        // onChange={ReceiveNotificationsFunc}
                        sx={{
                          padding: 0, // remove padding
                        }}
                      />
                      {i18n.resolvedLanguage === "en" ? <></> : <>&nbsp;</>}
                      {t("profile.Trackprice")}
                    </p>
                    {/* <button>Track price</button> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </>
    );
  };

  const MobileCustomWish = () => {
    return (
      <>
        {WishListData.length === 0 ? (
          <div
            style={{
              paddingLeft: 20,
              paddingTop: 20,
            }}
          >
            <a style={{ fontSize: 12 }}>No orders found</a>
          </div>
        ) : (
          <div
            style={{
              display: "grid",
              //gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
              gridTemplateColumns:
                MyWidth <= 1024 ? "repeat(1, 1fr)" : "repeat(3, 1fr)", // Exactly 3 items per row
              gap: "20px",
              marginBottom: "20px",
            }}
          >
            {filteredData.map((item) => (
              <div>
                <div
                  key={item.id}
                  style={{
                    display: "flex",
                    width: "100%",
                    //height: 100,
                    //backgroundColor: "blue",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      flexDirection: "row",
                    }}
                  >
                    <div
                      style={{
                        width: "30%",
                        //backgroundColor: "red",
                        backgroundColor: "#fafafa",

                        minWidth: 150,
                      }}
                    >
                      <img
                        src={item.image}
                        alt="Sample"
                        style={{
                          maxHeight: "100%",
                          maxWidth: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    <div
                      style={
                        {
                          //backgroundColor: "green"
                        }
                      }
                    >
                      <p
                        style={{
                          margin: 0,
                          paddingBottom: 10,
                          fontSize: 15,
                          paddingTop: 10,
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleDivClick2("product", item.productId);
                        }}
                      >
                        {item.name}
                      </p>
                      <p
                        style={{
                          margin: 0,
                          paddingBottom: 5,
                          opacity: 0.5,
                          fontSize: 15,
                        }}
                      >
                        {item.productType}
                      </p>
                      <p style={{ margin: 0, fontSize: 15, color: "#22c55e" }}>
                        {item.inStock === "Yes"
                          ? t("profile.InStock")
                          : t("profile.Outofstock")}{" "}
                        {item.dropDown}
                      </p>
                      {item.discount === 0 ? (
                        <>
                          {item.priceInsteadOf === 0 ? (
                            <a
                              style={{
                                fontSize: 15,
                                paddingBottom: 5,
                              }}
                            >
                              ₪{item.price}
                            </a>
                          ) : (
                            <>
                              <a
                                style={{
                                  margin: 0,
                                  color: "red",
                                  textDecoration: "line-through",
                                  fontSize: 15,
                                  paddingBottom: 5,
                                }}
                              >
                                ₪{item.price}
                              </a>
                              &nbsp;&nbsp;
                              <a
                                style={{
                                  fontSize: 15,
                                }}
                              >
                                ₪{item.priceInsteadOf}
                              </a>
                            </>
                          )}
                          <a
                            style={{
                              fontSize: 12,
                            }}
                          >
                            &nbsp;
                          </a>
                        </>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            flexDirection:
                              item.theDeal === 1 ? "row" : "column",
                            //flexDirection: "row",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            {item.theDeal === 1 ? (
                              <>
                                <p
                                  style={{
                                    margin: 0,
                                    paddingBottom: 5,
                                    fontSize: 15,
                                    color: "red",
                                  }}
                                >
                                  ₪
                                  {(
                                    item.price -
                                    (item.price * item.discount) / 100
                                  ).toFixed(2)}
                                </p>
                                &nbsp; &nbsp;
                                <p
                                  style={{
                                    margin: 0,
                                    paddingBottom: 5,
                                    fontSize: 15,
                                    textDecoration: "line-through",
                                  }}
                                >
                                  ₪{item.price}
                                </p>
                              </>
                            ) : (
                              <>
                                <p
                                  style={{
                                    margin: 0,
                                    paddingBottom: 5,
                                    fontSize: 15,
                                    //textDecoration: "line-through",
                                  }}
                                >
                                  ₪{item.price}
                                </p>
                              </>
                            )}
                          </div>
                          <div>
                            <a style={{ margin: 0 }}>
                              <a
                                style={{
                                  fontSize: 15,
                                }}
                              >
                                {item.theDeal === 1 ? (
                                  <>
                                    &nbsp; &nbsp;
                                    <a
                                      style={{
                                        backgroundColor: "#6b21a8",
                                        color: "white",
                                        margin: 0,
                                        marginBottom: 5,
                                        paddingLeft: 5,
                                        paddingRight: 5,
                                        fontSize: 15,
                                      }}
                                    >
                                      -{item.discount}%
                                    </a>
                                    <a
                                      style={{
                                        fontSize: 12,
                                      }}
                                    >
                                      &nbsp;
                                    </a>
                                  </>
                                ) : (
                                  // "Buy " + theDeal + "pcs to get -" + item.discount
                                  <>
                                    <a
                                      style={{
                                        backgroundColor: "#6b21a8",
                                        color: "white",
                                        fontSize: 12,
                                        paddingLeft: 5,
                                        paddingRight: 5,
                                      }}
                                    >
                                      Buy 2 pcs to get -{item.discount}% off
                                      every {item.theDeal}
                                      {item.theDeal === 2 ? "nd" : "th"} item
                                    </a>
                                  </>
                                )}
                              </a>
                            </a>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      //backgroundColor: "yellow",
                      flexDirection: "column",
                      alignItems: "flex-end",
                      justifyContent: "space-between",
                    }}
                  >
                    <img
                      src={CloseImg}
                      alt="close"
                      style={{
                        width: 22,
                        height: 22,
                        cursor: "pointer",
                        marginBottom: 15,
                      }}
                      onClick={() => {
                        DeleteFromWishList(item.id);
                      }}
                    />
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: 15,
                      }}
                      onClick={() => {
                        CreateProduct(item.id);
                      }}
                    >
                      <a style={{ fontSize: 15 }}>{t("profile.Buy")}</a>
                      <img
                        src={shoppingbag}
                        alt="shoppingbag"
                        style={{
                          width: 20,
                          height: 20,
                        }}
                      />
                    </div>
                    {/* <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        paddingTop: 10,
                        //backgroundColor: "gray",
                        width: 90,
                        alignItems: "center",
                      }}
                    >
                      <Checkbox
                        {...label}
                        icon={
                          <Box
                            sx={{
                              width: 18,
                              height: 18,
                              border: "1.4px solid black", // border for unchecked state
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginRight: 1,
                            }}
                          />
                        } // Unchecked icon
                        checkedIcon={
                          <Box
                            sx={{
                              width: 18,
                              height: 18,
                              border: "1.4px solid black", // border for checked state
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginRight: 1,
                            }}
                          >
                            <Box
                              sx={{
                                width: 10, // smaller square inside
                                height: 10,
                                backgroundColor: "black", // color of the small square
                              }}
                            />
                          </Box>
                        } // Checked icon with small square
                        checked={item.trackPrice === 1} // Check based on PriceTrack value
                        onChange={() => handleCheckboxChange(item.id)} // Update state by ID
                        sx={{
                          padding: 0, // remove padding
                        }}
                      />
                      <a style={{ fontSize: 13 }}>Track price</a>
                    </div> */}
                  </div>
                </div>
                <div
                  style={{
                    height: "0.1px",
                    backgroundColor: "#f4f4f5",
                    width: "100%",
                    marginTop: 10,
                  }}
                ></div>
              </div>
            ))}
          </div>
        )}
      </>
    );
  };
  const [MyOpen, setMyOpen] = React.useState(false);

  const handleOpenDialog = () => {
    setMyOpen(true);
  };

  const handleCloseDialog = () => {
    setMyOpen(false);
  };
  if (!Loading)
    return (
      <div
        style={{
          justifyContent: "center",
          display: "flex",
          alignItems: "center",
          paddingTop: 50,
        }}
      >
        <Lottie
          style={{ height: 40, width: 40 }}
          animationData={LottifileLoading}
        />
      </div>
    );

  return (
    <div>
      {CartDialog()}
      <AllCategoriesCartDialog
        MyOpen={MyOpen}
        onClose={handleCloseDialog}
        CartData={CartData}
        MySaveTotalPrice={SaveTotalPrice}
        onCreateProduct2={CreateProduct2}
        handleDivClick2={handleDivClick2}
        MyRecommendedProductsData={RecommendedProductsData}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingLeft: MyWidth <= 768 ? "0%" : "10%",
        }}
      >
        <div style={{ paddingTop: 50 }}>
          <p style={{ fontWeight: 500, fontSize: 25, marginLeft: 10 }}>
            {t("profile.Wishlist")}
          </p>
        </div>
        {/* Custom category selection UI */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            paddingBottom: 40,
          }}
        >
          {categories.map((category, index) => (
            <div
              key={index}
              style={{
                margin: 10,
                padding: MyWidth < 768 ? 5 : 10,
                paddingLeft: MyWidth < 768 ? 10 : 20,
                paddingRight: MyWidth < 768 ? 10 : 20,
                backgroundColor:
                  category === selectedCategory ? "black" : "#f5f5f4",
                borderRadius: 20,
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => setSelectedCategory(category)}
            >
              <a
                style={{
                  color: category === selectedCategory ? "#f5f5f4" : "black",
                  textDecoration: "none",
                }}
              >
                {category}
              </a>
            </div>
          ))}
        </div>
        {MyWidth <= 1024 ? (
          <>{MobileCustomWish()}</>
        ) : (
          <>{WindowsCustomWish()}</>
        )}
      </div>
    </div>
  );
}
